import { IconButton, OpenIcon } from "@minervaproject/fds";

function OpenInNewTab({
  url,
  handleOpenInNewTab,
}: {
  url?: string;
  handleOpenInNewTab?: () => void;
}) {
  const defaultHandleOpenInNewTab = () => {
    window.open(url, "_blank");
    window.focus();
  };

  return (
    <IconButton onClick={handleOpenInNewTab || defaultHandleOpenInNewTab}>
      <OpenIcon width={16} height={16} color="var(--black-tint-70)" />
    </IconButton>
  );
}

export { OpenInNewTab };
